import { differenceInDays } from 'date-fns';

import type { useConfluenceStandardToPremiumExperimentQuery as useConfluenceStandardToPremiumExperimentQueryType } from './graphql/__types__/useConfluenceStandardToPremiumExperimentQuery';

/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */
export const getTrialDaysLeftFromQuery = (
	queryData: useConfluenceStandardToPremiumExperimentQueryType | undefined,
) => {
	const trialEndDate = queryData?.license?.trialEndDate;
	return getTrialDaysLeft(trialEndDate);
};

/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */
export const getTrialDaysLeft = (trialEndDate: string | null | undefined) => {
	if (!trialEndDate) {
		return null;
	}
	// +1 day to round up for fractional days
	return differenceInDays(new Date(trialEndDate), new Date()) + 1;
};
